module.exports = __webpack_public_path__ + "media/se_shot_handgun.5cdf43c7.mp3";